import axiosConfig from '../axiosConfig';
import store from "../storeConfig";

import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";

const baseURL = getEnvVars().apiUrl;
export default function emptyFunction() {
}

export function resetCardError() {
    store.dispatch({
        type: 'CARD_ERROR_MESSAGE',
        message: ""
    });
}

export function getCards(code = '') {
        // takes array and adds balance data
        Auth.currentSession().then((cognitoUserSession) => {
            var axi = axios.create({
                baseURL: baseURL,
                withCredentials: false,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": cognitoUserSession.getIdToken().getJwtToken()
                }
            });
    
            axi.get('cards/getCards', {
                params: {
                    code: code
                }
            }).then( (result) => {
                // console.log(result);
                    store.dispatch({
                        type: 'LOAD_CARDS',
                        cards: result.data.cards
                    });
                    return true;
            });
        });
}

export function addCard(dataPacket) {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('cards/addCards', dataPacket).then(async (result) => {
              // console.log(result);
              if (result.data.card === undefined) {
                store.dispatch({
                    type: 'CARD_ERROR_MESSAGE',
                    message: result.data.errors[0]
                });
                return false;
              }
                store.dispatch({
                    type: 'ADD_SINGLE_CARD',
                    card: result.data.card
                });
                return true;
        }).catch((error) => {
            if (error.response) {
                if (error.response.status == 504)
                    store.dispatch({
                        type: 'CARD_ERROR_MESSAGE',
                        message: "API Timeout"
                    });
                else
                    store.dispatch({
                        type: 'CARD_ERROR_MESSAGE',
                        message: "Misc Error"
                    });
                return false;
            }
        });
    });
}

export function removeCard(cardId) {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        var dataPacket = {
            cardId: cardId
        };

        axi.post('cards/removeCard', dataPacket).then(async (result) => {
            // console.log(result);
                store.dispatch({
                    type: 'CARD_REFRESH_FLAG'
                });
                return true;
        });
    });
}

export function getBanks() {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('cards/getBanks').then(async (result) => {
            // console.log(result);
                store.dispatch({
                    type: 'LOAD_BANKS',
                    banks: result.data.banks
                });
                return true;
        });
    });
}